"use client"

import { CircleEllipsis } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CircleEllipsisIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CircleEllipsisIcon = component(Icon)({ as: CircleEllipsis })
